import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import Image from './Image';
import useStyles from './PreviewItem.styles';

type TPreviewItem = {
  title: string;
  previewImage: PictureRef;
  url: string;
  UID: string;
  year?: string;
  role?: string;
  email?: string;
};

const PreviewItem: FC<TPreviewItem> = ({
  title,
  previewImage,
  url,
  year,
  role,
  email,
}) => {
  const cls = useStyles();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const sizes = `(max-width: 768px) calc(100vw - 20px),
	(max-width: 1024px) calc((100vw - 300px) / 2),
	(max-width: 1280px) calc((100vw - 350px) / 2),
	(max-width: 1920px) calc((100vw - 400px) / 2),
	(max-width: 3000px) 1050px`;

  return (
    <article className={cls.root} ref={ref} data-show={inView}>
      <div className={cls.frame}>
        <div className={cls.inner}>
          <h2 className={cls.title}>
            {/* Second line shares the span with the title so it keeps the
                same type and tight stacking as a project's year. */}
            <span>
              {title}
              {year && (
                <>
                  <br /> {year}
                </>
              )}
              {role && (
                <>
                  <br />
                  <span className={cls.titleRole}>{role}</span>
                </>
              )}
            </span>
          </h2>
          {previewImage && (
            <figure className={cls.figure}>
              <Image
                alt={previewImage.Legend}
                pictureRef={previewImage}
                sizes={sizes}
              />
            </figure>
          )}
          <Link to={url} className={cls.link} />
        </div>
      </div>
    </article>
  );
};

export default PreviewItem;
